import React, {useEffect, useState} from 'react';
import QRCode from "qrcode";

function Qrcode({id, index=0, width = 100, height = 100}) {

    const [url, setUrl] = useState('');

    useEffect(() => {
        if(id) {
            QRCode.toDataURL(`https://qrcode.theassetpro.com/api/qr/${id}`)
                .then(url => {
                    setUrl(url);
                });
        }
    }, []);

    return (
        <div key={'' + id + index}>
            <img alt='new_qrcode' width={width} height={height} src={url}/>
        </div>
    );
}

export default Qrcode;
